import { DataTabs } from '@/legacy/Data/types';

enum WorkspaceSections {
  Applications = 'applications',
  Models = 'models',
  Data = 'data',

  // New navigation
  ModelAPIs = 'model-apis',
  Chains = 'chains',
  Training = 'training',
  Overview = 'overview',
}

interface MatchParams {
  tabId?: DataTabs;
  section?: WorkspaceSections;
}

enum Filter {
  All = 'all',
  RUNNING = 'running',
  SCALED_TO_ZERO = 'scaled_to_zero',
  INACTIVE = 'inactive',
  FAILED = 'failed',
}

enum SortBy {
  PRODUCTION = 'production',
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

enum SortByTraining {
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

export { WorkspaceSections, MatchParams, Filter, SortBy, SortByTraining };
